import React from 'react';

const Return = () => {
  return (
    <div className="px-4 py-8 sm:px-6 md:mt-28 lg:px-8">
      <div className="prose prose-lg max-w-none">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Return Policy</h1>
        <p className="text-gray-600 mb-8">Last Updated: June 2025</p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Return Eligibility</h2>
        <p className="text-gray-700 mb-6">
          Your purchase is eligible for a return if it meets the following criteria: the product must be returned in its original packaging (used or unused), reach the specified address listed on our website, and arrive within 15 days of the purchase date. Damaged products will not be accepted.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Refund Process</h2>
        <p className="text-gray-700 mb-6">
          To process a refund, customers must initiate the return process and send the product to the specified address. Once the product is received and inspected, refunds will be credited to the original payment method within 10 business days, excluding shipping costs.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Shipping Responsibility</h2>
        <p className="text-gray-700 mb-6">
          The return process is customer-initiated, and customers are responsible for ensuring the product is shipped to the specified address. Return shipping costs are not covered unless the return is due to a manufacturing defect or error.
        </p>

        <p className="text-gray-700 mb-6">
          For any return inquiries, please contact us at <a href="mailto:israelitesshopping171@gmail.com" className="text-blue-600 hover:text-blue-800">israelitesshopping171@gmail.com</a>.
        </p>
      </div>
    </div>
  );
};

export default Return;